function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5822 3.31918C12.7864 1.88996 12.6761 0.588674 12.6408 0.121094C11.5778 0.182854 10.347 0.844524 9.64566 1.66059C8.87371 2.534 8.41935 3.61474 8.5164 4.83222C9.66771 4.92044 10.7176 4.32935 11.5822 3.31919V3.31918ZM14.0793 10.562C14.0705 8.94315 14.8027 7.72126 16.2849 6.82138C15.4556 5.63478 14.2028 4.98192 12.5486 4.854C10.9827 4.73049 9.27114 5.76711 8.64475 5.76711C7.98308 5.76711 6.46563 4.89811 5.27462 4.89811C2.81319 4.93781 0.197373 6.86108 0.197373 10.7738C0.197373 11.9295 0.409112 13.1235 0.832582 14.3556C1.39721 15.9746 3.43517 19.9446 5.56135 19.8784C6.67296 19.852 7.45815 19.0888 8.90501 19.0888C10.3078 19.0888 11.0356 19.8784 12.2751 19.8784C14.419 19.8475 16.2628 16.2392 16.801 14.6159C13.9249 13.2617 14.0793 10.6459 14.0793 10.562H14.0793Z",
  fill: "white"
});
function SvgAppleA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleA);
export default __webpack_public_path__ + "static/media/apple-a.f63730b015aae379264c78cda5162ca3.svg";
export { ForwardRef as ReactComponent };